import { createApp } from "vue";
import App from "../App.vue";
import { loadArenas } from "../config/arenas";
import "../style.css";

// Decode the baked-in map config once before mounting, so arenaFor() is ready.
loadArenas().finally(() => createApp(App).mount("#app"));
